(function () {
  'use strict';

  /* @ngdoc object
   * @name snap
   * @description
   *
   */
  angular
    .module('snap', [
      'ui.router'
    ]);
}());
